<p ds-typography class="dealer-summary">
  <strong></strong>
</p>
